- Список приглашений для разработчиков сделать какое-то приложение на $mol
- Нужно добавить список, который давал бы ссылку на приложение, значок откуда пришёл, сделано или нет приложение
- $invite_app $mol_book2_catalog
	menu_title \Приглашения в $mol
	param \app
	Placeholder null
	menu_tools /
		<= GitHub $mol_link_source uri \https://github.com/Lyumih/invite
		- <= Visible $mol_check_icon Icon <= Checked_icon $mol_icon_eye
	spreads *
		- https://habr.com/ru/articles/764650/ - Фонетический словарь
		dict <= Dict_app $invite_dict
$invite_app $invite_dict
